import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./UserDropDown.css";
import SwitchRoleSubmenu from "./SwitchRoleSubmenu";
import APP_CONFIG from "../../../config/appConfig";

const UserDropDown = ({
  user,
  currentRoleKey,
  filteredRoles,
  configUserRoles,
  switchUser,
  handleLogout,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = (e) => {
    e.preventDefault(); // Prevent link navigation
    setIsOpen((prev) => !prev);
  };

  return (
    <ul className="nav-top-navbar">
      <li className="nav-top-nav-item">
        <div className="nav-top-dropdown" ref={dropdownRef}>
          <button className="nav-top-avatar-toggle" onClick={toggleDropdown}>
            {/* <span className="nav-top-avatar-name">
              {user?.firstname} {user?.lastname}
            </span> */}

            {/* +++++++++++++++++++++++++++++++++++++++++++++++++ */}
            <img
              className="avatar_img"
              src={
                APP_CONFIG.AVATAR_URL +
                "background=999999&color=fff&name=" +
                user?.firstname +
                " " +
                user?.lastname +
                "&rounded=true&normal=true&font-size=0.40"
              }
              alt="icon"
            />
            {/* +++++++++++++++++++++++++++++++++++++++++++++++++ */}

            {/* <img
              src="/img/chevron-down.png"
              className="dropdown_arrow"
              alt="dropdown arrow"
            /> */}
          </button>

          <ul
            className={`nav-top-dropdown-menu ${isOpen ? "nav-top-show" : ""}`}
          >
            {currentRoleKey === "SALES_DEMO" && (
              <li>
                <Link className="nav-top-dropdown-item" to="/sales_accounts">
                  <i className="fa fa-exchange nav-top-icon-blue"></i> Switch to
                  Demo Login
                </Link>
              </li>
            )}

            {/* Memory documents upload section made hidden for now as asked by Dibya/Kaushik */}
            {/* <li className="nav-top-switch-role">
              <Link
                className="nav-top-dropdown-item nav-top-logout-btn"
                to="/users/documents"
                style={{ color: "black" }}
              >
                <i className="fa fa-user-circle nav-top-icon-blue"></i>Upload Documents
              </Link>
            </li> */}

            <li className="nav-top-switch-role">
              <Link
                className="nav-top-dropdown-item nav-top-logout-btn"
                to="/users/view_profile"
                style={{ color: "black" }}
              >
                <i className="fa fa-user-circle nav-top-icon-blue"></i>View
                Profile
              </Link>
            </li>

            {/* <li>
              <Link
                className="nav-top-dropdown-item"
                to="/users/change_password"
              >
                <i className="fa fa-key nav-top-icon-blue"></i> Change Password
              </Link>
            </li> */}

            {filteredRoles?.length > 0 && (
              <SwitchRoleSubmenu
                roles={filteredRoles}
                configUserRoles={configUserRoles}
                switchUser={switchUser}
              />
            )}

            <li className="nav-top-switch-role">
              <button
                className="nav-top-dropdown-item nav-top-logout-btn"
                onClick={handleLogout}
              >
                <i className="fa fa-sign-out nav-top-icon-red"></i> Sign Out
              </button>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  );
};

export default UserDropDown;
